import { ThemeProvider } from '@material-tailwind/react/context/theme';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { QueryClientProvider } from 'react-query';
import { BackendUnreachableScreen } from './components/backend-unreachable-screen/backend-unreachable-screen';
import Footer from './components/footer';
import Navbar from './components/navbar';
import { StagingBanner } from './components/staging-banner/staging-banner';
import { queryClient } from './lib/react-query-client';
import { theme } from './material-tailwind-theme';
import { AuthStateProvider } from './providers/auth-state-provider';
import { I18nProvider } from './providers/i18n-provider';
import { AppRouter } from './routers/app-router';
import { useConnectivityStore } from './stores/useConnectivityStore';
// Imported for its module-load side effect: applies the persisted color
// scheme to <html> before first paint, avoiding a light-mode flash.
import './stores/useColorSchemeStore';
import * as Sentry from '@sentry/react';

function App() {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
  );

  const isUnreachable = useConnectivityStore((state) => state.isUnreachable);

  return (
    <Sentry.ErrorBoundary>
      {isUnreachable && <BackendUnreachableScreen />}
      <StagingBanner />
      <AuthStateProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider value={theme}>
            <I18nProvider>
              <AppRouter />
            </I18nProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </AuthStateProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
